import React, { Component } from "react";
import Axios from "axios";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import Constant from "../Constant";
import { getAccessToken } from "../../hooks/AccessToken";

class RegistrationForms extends Component {
  state = {
    forms: [],
  };

  fetchRegistrationForms = async () => {
    const token = getAccessToken();
    console.log("Access token:", token);
    try {
      const response = await Axios.get(
        Constant.apiBasePath + "registration-forms/get-all",
        {
          headers: { token },
        }
      );
      console.log("API response:", response.data);
      if (response.data.message === "Forms retrieved successfully") {
        console.log("Updating state with forms:", response.data.data);
        this.setState({ forms: response.data.data }, () => {
          console.log("State updated successfully:", this.state.forms);
        });
      } else {
        alert(response.data.message);
      }
    } catch (err) {
      console.error("Error in API call:", err);
    }
  };

  handleDelete = async (id) => {
    const token = getAccessToken();
    if (window.confirm("Are you sure you want to delete this form?")) {
      try {
        const response = await Axios.delete(
          Constant.apiBasePath + `registration-forms/${id}`,
          {
            headers: { token },
          }
        );
        if (response.data.status === Constant.statusSuccess) {
          alert("Form deleted successfully!");
          this.fetchRegistrationForms();
        } else {
          alert(response.data.message);
        }
      } catch (err) {
        console.error("Error deleting registration form:", err);
        alert("Something went wrong. Please try again.");
      }
    }
  };

  handleToggleActive = async (formId, currentActive) => {
    const token = getAccessToken();
    try {
      console.log("Current active status:", currentActive);
      const response = await Axios.patch(
        `${Constant.apiBasePath}registration-forms/toggle-active/${formId}`,
        {},
        {
          headers: { token },
        }
      );
      console.log(response.data);

      // Update the local state without reloading
      this.setState(
        (prevState) => {
          const updatedForms = prevState.forms.map((form) => {
            if (form._id === formId) {
              const newActive = !currentActive;
              console.log(
                "Updating form:",
                form.name,
                "from",
                form.active,
                "to",
                newActive
              );
              return { ...form, active: newActive };
            }
            return form;
          });
          return { forms: updatedForms };
        },
        () => {
          // Verify the state was updated
          console.log("State after update:", this.state.forms);
        }
      );
    } catch (err) {
      console.error("Error toggling form status:", err);
      alert("Something went wrong. Please try again.");
    }
  };

  componentDidMount() {
    this.fetchRegistrationForms();
  }

  render() {
    const { forms } = this.state;

    return (
      <div className="content-page contest-management-page event-management-page registration-forms-page">
        <div className="content page-content-spaced">
          <div className="event-management-header">
            <div className="header-content">
              <div className="header-title">
                <h4 className="page-title-heading">Event Registration Forms</h4>
                <p className="header-subtitle">
                  Manage registration forms, questions, and response access.
                </p>
              </div>
              <div className="header-actions">
                <Link
                  to="/add-registration-form"
                  className="btn btn-primary btn-add-event contest-add-match"
                >
                  + Add New Form
                </Link>
              </div>
            </div>
          </div>

          <div className="event-management-body">
            <div className="card contest-like-card">
                <div className="card-body">
                  <div className="table-wrapper contest-submissions-table-responsive contest-like-table-responsive">
                      <table className="table event-table contest-submissions-table contest-like-table">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Success Message</th>
                            <th>Event Type</th>
                            <th>Questions</th>
                            <th className="registration-response-count-col">Response Count</th>
                            <th className="registration-status-col">Status</th>
                            <th>Image</th>
                            <th>Mobile Image</th>
                            <th className="actions-col">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {forms.map((form) => (
                            <tr key={form._id}>
                              <td className="namecol">{form.name}</td>
                              <td className="namecol">{form.description}</td>
                              <td>{form.successMsg}</td>
                              <td>{form.eventType}</td>
                              <td>{form.questions.length}</td>
                              <td className="registration-response-count-col">{form.responseCount}</td>
                              <td className="registration-status-col">
                                <button
                                  type="button"
                                  onClick={() =>
                                    this.handleToggleActive(
                                      form._id,
                                      form.active
                                    )
                                  }
                                  className={`contest-status-pill ${
                                    form.active
                                      ? "is-active"
                                      : "is-inactive"
                                  } registration-status-btn`}
                                >
                                  {form.active ? "ACTIVE" : "INACTIVE"}
                                </button>
                              </td>
                              <td>
                                {form.thumbnail && (
                                  <img
                                    src={form.thumbnail}
                                    alt={`${form.name} Preview`}
                                    style={{ width: "100px", height: "auto" }}
                                  />
                                )}
                              </td>
                              <td>
                                {form.mobileImage && (
                                  <img
                                    src={form.mobileImage}
                                    alt={`${form.name} Mobile Preview`}
                                    style={{ width: "100px", height: "auto" }}
                                  />
                                )}
                              </td>
                              <td className="actions-col registration-form-actions-col">
                                <div className="registration-form-actions">
                                  <Link
                                    to={`/edit-registration-form/${form._id}`}
                                    className="contest-icon-btn"
                                    title="Edit"
                                    aria-label="Edit registration form"
                                  >
                                    <FontAwesomeIcon icon={faEdit} style={{ fontSize: "13px" }} />
                                  </Link>
                                  <button
                                    type="button"
                                    onClick={() => this.handleDelete(form._id)}
                                    className="contest-icon-btn danger"
                                    title="Delete"
                                    aria-label="Delete registration form"
                                  >
                                    <FontAwesomeIcon icon={faTrashAlt} style={{ fontSize: "13px" }} />
                                  </button>
                                  <Link
                                    to={`/registration-form-questions/${form._id}`}
                                    className="btn btn-info"
                                  >
                                    Questions
                                  </Link>
                                  <Link
                                    to={`/user-response/${form._id}`}
                                    className="btn btn-info"
                                  >
                                    User response
                                  </Link>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    );
  }
}

export default RegistrationForms;
